import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Users, UserCheck, ListTodo, Menu } from 'lucide-react';

const TABS = [
  { to: '/', icon: LayoutDashboard, label: 'Dashboard', end: true },
  { to: '/leads', icon: Users, label: 'Leads' },
  { to: '/buyers', icon: UserCheck, label: 'Buyers' },
  { to: '/tasks', icon: ListTodo, label: 'Tasks' },
];

export function MobileTabBar({ onMore }) {
  const cls = active => `flex flex-1 flex-col items-center justify-center gap-0.5 py-2 text-[10px] font-medium transition-colors ${active ? 'text-blue-400' : 'text-slate-400'}`;
  return (
    <nav className="md:hidden fixed inset-x-0 bottom-0 z-30 flex border-t border-[#1F293D] bg-[#0D131F]/95 backdrop-blur-xl pb-[env(safe-area-inset-bottom)]" data-testid="mobile-tab-bar">
      {TABS.map(({ to, icon: Icon, label, end }) => (
        <NavLink key={to} to={to} end={end} className={({ isActive }) => cls(isActive)} data-testid={`mobile-tab-${label.toLowerCase()}`}>
          <Icon className="h-5 w-5" />{label}
        </NavLink>
      ))}
      <button onClick={onMore} className={cls(false)} data-testid="mobile-tab-more"><Menu className="h-5 w-5" />More</button>
    </nav>
  );
}
